import {emptySplitApi} from './baseApi';

export const inviteResendApi = emptySplitApi
  .enhanceEndpoints({
    addTagTypes: ['InviteController'],
  })
  .injectEndpoints({
  endpoints: build => ({
    patchInviteByIdResend: build.mutation<
      {success?: boolean; message?: string},
      {id: string}
    >({
      query: ({id}) => ({
        url: `/invite/${id}/resend`,
        method: 'PATCH',
      }),
      invalidatesTags: ['InviteController'],
    }),
  }),
  overrideExisting: false,
});

export const {usePatchInviteByIdResendMutation} = inviteResendApi;